// extracted by mini-css-extract-plugin
module.exports = {"label":"AccountFieldLabel_label__1SMVJ","required":"AccountFieldLabel_required__2O25f"};